export default "__VITE_ASSET__CSqgeBSv__"